<template>
  <div class="info-container">
    <div
      style="width: 50%; margin-top: 20px; margin-right: 20px; height: 700px"
    >
      <a-button @click="handleOk()">download</a-button>
      <a-modal
        title="download"
        :visible="visible"
        :confirm-loading="confirmLoading"
        @ok="handleOk"
        @cancel="handleCancel"
      >
        <a-input v-model="downloadPassword" />
      </a-modal>
      <a-table
        rowKey="id"
        :columns="columns"
        :data-source="dataSource"
        :pagination="{ pageSize: 50 }"
        :scroll="{ y: 500, x: '50%' }"
        id="table-data"
        @search="handleSearchHoleByName"
      />
    </div>
    <a-carousel v-if="hole" style="width: 600px" arrows>
      <div slot="prevArrow" class="custom-slick-arrow" style="">
        <a-icon type="left-circle" />
      </div>
      <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
        <a-icon type="right-circle" />
      </div>
      <img
        style="width: 800px"
        v-for="(o, index) in hole.length"
        :key="o"
        :src="`https://ma-file-1314929303.cos.ap-chengdu.myqcloud.com/${hole[index]}.png`"
      />
    </a-carousel>
    <!-- <div
      ref="myEchart"
      class="myEchart"
      style="width: 50%; height: 500px; margin-top: 30px; margin-right: 20px"
    ></div> -->
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { addNumber, getBchronByHole } from '@/api/index';
import { getSymbol, getColor } from '@/utils/getLabel';
import ExportExcel from '@/utils/exportExcel';
export default {
  name: 'infoName',
  data() {
    return {
      columns: [
        {
          title: 'Hole',
          dataIndex: 'hole',
          //   key: 'hole',
          width: 100,
        },
        {
          title: 'Depth(m)',
          dataIndex: 'depth',
          width: 100,
        },
        {
          title: 'Age(Ma)',
          dataIndex: 'age_ma',
          width: 100,
        },
        {
          title: 'Age_uncetainty',
          dataIndex: 'age_uncertainty',
          width: 100,
        },
        {
          title: 'Source',
          dataIndex: 'source',
          width: 100,
          // sorter: (a, b) => a.name.length - b.name.length,
        },
        {
          title: 'Data_Used',
          dataIndex: 'data_Used',
          width: 100,
        },
        {
          title: 'Model_Quality',
          dataIndex: 'model_Quality',
          width: 100,
        },
        {
          title: 'Revision_Number',
          dataIndex: 'revision_Number',
          width: 100,
        },
        {
          title: 'Method',
          dataIndex: 'method',
          width: 100,
        },
        {
          title: 'Comment',
          dataIndex: 'comment',
          width: 100,
        },
        {
          title: 'Processd_Date',
          dataIndex: 'processed_Date',
          width: 100,
        },
        {
          title: 'Leg_Hole',
          dataIndex: 'leg_Hole',
          width: 100,
        },
        {
          title: 'Leg',
          dataIndex: 'leg',
          width: 100,
        },
        {
          title: 'Site',
          dataIndex: 'site',
          width: 100,
        },
      ],
      dataSource: [],
      PangaeaData: [],
      BchronData: [],
      StraData: [],
      mychartMap: '',
      ModalText: 'Content of the modal',
      visible: false,
      confirmLoading: false,
      downloadPassword: '',
    };
  },
  watch: {
    async hole() {
      console.log(this.hole);
      // this.dataSource = [];
      this.BchronData = [];
      this.PangaeaData = [];
      this.StraData = [];

      await getBchronByHole(this.hole).then((res) => {
        console.log(res);
        this.dataSource = [];
        res.map((list) => {
          this.dataSource = [...list.data];
        });
        // this.dataSource = res;
      });
      // await getPangaeaByHole(this.hole).then((res) => {
      //   console.log(res);
      //   for (let i = 0; i < res.length; i++) {
      //     const pdata = [];
      //     res[i].map((item) => {
      //       item.depth !== undefined ? '' : (item.depth = item.depth_m);
      //       item.age = item.age_Model;
      //       item.source = 'Pangaea:   ' + item.doi;

      //       this.dataSource.push(item);
      //       pdata.push(item);
      //     });
      //     this.PangaeaData.push(pdata);
      //     console.log('pdata', pdata);
      //   }
      // });
      // await getStratigraphicEventsByHole(this.hole).then((res) => {
      //   console.log(res);
      //   this.dataSource = res;
      //   // res.map((item) => {
      //   //   // item.age = item.standard_age;
      //   //   // item.source = item.resources;
      //   //   // this.dataSource.push(item);
      //   //   this.StraData.push(item);
      //   // });
      // });
      this.changeOption();
    },
  },
  mounted() {
    // const Hole = this.$route.query.Holevalue;
    // getBchronPangaea(Hole).then((res) => {
    //   this.data = res;
    //   res.map((item) => {
    //     console.log(item);
    //   });
    // });
    // this.initEcharts();
  },
  methods: {
    initEcharts() {
      this.mychartMap = echarts.init(this.$refs.myEchart);
    },
    changeOption() {
      let series = [];
      let bchronSeries = this.BchronData.map((item) => [item.age, item.depth]);
      let bchronSeriestop = this.BchronData.map((item) => [
        item.age + item.sd,
        item.depth,
      ]);
      let flag = 0;
      let bchronSeriesbottom = this.BchronData.map((item) => {
        if (!flag) {
          bchronSeriestop.unshift([item.age - item.sd, item.depth]);
          flag = 1;
        }
        return [item.age - item.sd, item.depth];
      });
      bchronSeriesbottom.push([
        this.BchronData[this.BchronData.length - 1].age +
          this.BchronData[this.BchronData.length - 1].sd,
        this.BchronData[this.BchronData.length - 1].depth,
      ]);
      console.log('Pangaea', this.PangaeaData);

      // let pangaeaSeries = this.PangaeaData.map((item) => [
      //   item.age,
      //   item.depth,
      // ]);
      // let pangaeaSeries = [];
      // for (let i = 0; i < this.PangaeaData.length; i++) {
      //   const pdata = this.PangaeaData[i].map((item) => [item.age, item.depth]);
      //   pangaeaSeries.push(pdata);
      // }
      //       Bio_F Foraminifera
      // Bio_N Calcareous Nannofossil
      // Bio_R Radiolaria
      // Bio_D Diatom
      // RD Radiometric Dating
      // M Magnetostratigraphy
      let Foraminifera = [];
      let Calcareous = [];
      let Radiolaria = [];
      let Diatom = [];
      let Radiometric = [];
      let Magnetostratigraphy = [];
      this.StraData.map((item) => {
        switch (item.chrono_Type.toLowerCase()) {
          case 'bio_f':
            Foraminifera.push([item.standard_Age, item.depth]);
            break;
          case 'bio_n':
            Calcareous.push([item.standard_Age, item.depth]);
            break;
          case 'Bio_R'.toLocaleLowerCase():
            Radiolaria.push([item.standard_Age, item.depth]);
            break;
          case 'Bio_D'.toLowerCase():
            Diatom.push([item.standard_Age, item.depth]);
            break;
          case 'RD'.toLowerCase():
            Radiometric.push([item.standard_Age, item.depth]);
            break;
          case 'M'.toLowerCase():
            Magnetostratigraphy.push([item.standard_Age, item.depth]);
            break;
        }
      });

      // console.log('bchrombottom', pangaeaSeries);
      series.push({
        name: 'Bchron',
        type: 'line',
        // stack: 'Total',
        data: bchronSeries,
        symbolSize: 0,
        itemStyle: {
          color: 'black',
          opacity: 0,
        },
        lineStyle: {
          width: 4,
          color: 'black',
        },
      });

      series.push({
        name: 'Bchron',
        type: 'line',
        data: bchronSeriesbottom,
        // stack: 'Total',
        symbolSize: 0,
        itemStyle: {
          color: 'black',
          shadowColor: 'black',
          opacity: 0,
        },
        lineStyle: {
          width: 2,
          color: 'black',
        },
        areaStyle: {
          color: 'gray',
          opacity: 0.5,
          // origin: 'start',
        },
      });
      series.push({
        name: 'Bchron',
        type: 'line',
        data: bchronSeriestop,
        stack: 'Total',
        symbolSize: 0,
        areaStyle: {
          color: 'white',
          // origin: 'start',
          opacity: 1,
        },
        itemStyle: {
          color: 'black',
          shadowColor: 'black',
          opacity: 0,
        },
        lineStyle: {
          width: 2,
          color: 'black',
        },
      });
      // for (let i = 0; i < pangaeaSeries.length; i++) {
      //   series.push({
      //     name: 'Pangaea' + i,
      //     type: 'line',
      //     smooth: true,
      //     data: pangaeaSeries[i],
      //     symbolSize: 0,

      //     itemStyle: {
      //       color: 'purple',
      //       opacity: 0,
      //     },
      //     lineStyle: {
      //       width: 2,
      //       color: 'purple',
      //     },
      //   });
      // }

      series.push({
        name: 'Foraminifera',
        type: 'scatter',
        data: Foraminifera,
        symbolSize: 9,
        symbol: getSymbol('Bio_F'),
        itemStyle: {
          color: getColor('Bio_F'),
          // borderWidth: 1,
          // borderColor: 'green',
          emphasis: {
            symbolSize: 6,
          },
          borderWidth: 2,
          borderType: 'solid',
          // opacity: 0, // 透明度
          // color: 'white',
          borderColor: 'black',
        },
        z: 10,
      });
      series.push({
        name: 'Calcareous',
        type: 'scatter',
        data: Calcareous,
        symbolSize: 9,
        symbol: getSymbol('Bio_N'),
        itemStyle: {
          // color: 'green',
          // borderWidth: 1,
          // borderColor: 'green',
          color: getColor('Bio_N'),
          borderWidth: 2,
          borderType: 'solid',
          // opacity: 0, // 透明度
          // color: 'white',
          borderColor: 'black',
          emphasis: {
            symbolSize: 6,
          },
        },
        z: 10,
      });
      series.push({
        name: 'Radiolaria',
        type: 'scatter',
        data: Radiolaria,
        symbolSize: 9,
        symbol: getSymbol('Bio_R'),
        itemStyle: {
          color: getColor('Bio_R'),
          // borderWidth: 1,
          // borderColor: 'green',
          borderWidth: 2,
          borderType: 'solid',
          // opacity: 0, // 透明度
          // color: 'white',
          borderColor: 'black',
        },
        z: 10,
      });
      series.push({
        name: 'Diatom',
        type: 'scatter',
        data: Diatom,
        symbolSize: 9,
        symbol: getSymbol('Bio_D'),
        itemStyle: {
          color: getColor('Bio_D'),
          // borderWidth: 1,
          // borderColor: 'green',
          borderWidth: 2,
          borderType: 'solid',
          // opacity: 0, // 透明度
          // color: 'white',
          borderColor: 'black',
        },
        z: 10,
      });
      series.push({
        name: 'Radiometric',
        type: 'scatter',
        data: Radiometric,
        symbolSize: 9,
        symbol:
          'image://https://mystorage-1314929303.cos.ap-chengdu.myqcloud.com/star.png',
        itemStyle: {
          color: getColor('RD'),
          // borderWidth: 1,
          // borderColor: 'green',
          borderWidth: 2,
          borderType: 'solid',
          // opacity: 0, // 透明度
          // color: 'white',
          borderColor: 'black',
        },
        z: 10,
      });
      series.push({
        name: 'Magnetostratigraphy',
        type: 'scatter',
        data: Magnetostratigraphy,
        symbol: getSymbol('M'),
        symbolSize: 9,
        itemStyle: {
          color: getColor('M'),
          borderWidth: 2,
          borderType: 'solid',
          // opacity: 0, // 透明度
          // color: 'white',
          borderColor: 'black',
          // borderWidth: 1,
          // borderColor: 'green',
        },
        z: 10,
      });
      let option = {
        title: {
          text: 'Age Model',
          left: 50,
        },
        grid: {
          show: true,
          borderWidth: 2,
          left: '0',
          containLabel: true,
          shadowColor: 'black',
        },
        xAxis: {
          type: 'value',
          name: 'Age(Ma)',
          nameLocation: 'center',
          nameTextStyle: {
            padding: 20,
            fontSize: 20,
          },
          inverse: false,
          min: function (value) {
            return Math.floor(value.min - (value.max - value.min) * 0.2) < 0
              ? 0
              : Math.floor(value.min - (value.max - value.min) * 0.2);
          },
          max: function (value) {
            return Math.ceil(value.max + (value.max - value.min) * 0.2);
          },
          boundaryGap: false,
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          inverse: true,
          // max: function (value) {
          //   return Math.floor(value.max);
          // },
          splitLine: {
            show: false,
          },
        },
        legend: {
          // type: 'scroll',
          // data: [
          //   {
          //     name: 'Bchron',
          //     icon: 'none',
          //   },
          // ],
          show: true,
          left: 200,
          top: 10,
        },
        series: series,
      };
      if (option && typeof option === 'object') {
        this.mychartMap.setOption(option, true);
        console.log(this.mychartMap.getOption());
      }
      window.onresize = this.mychartMap.resize;
    },
    //导出excel
    toExcel() {
      ExportExcel(this.columns, this.dataSource, 'sedst');
    },
    handleSearchHoleByName(value) {
      console.log(value);
    },
    showModal() {
      this.visible = true;
    },
    handleOk() {
      // if (this.downloadPassword !== 'Malabcode') {
      //   this.$message.error('Code Error！');
      //   return;
      // }
      addNumber();
      this.confirmLoading = true;
      this.toExcel();
      setTimeout(() => {
        this.visible = false;
        this.confirmLoading = false;
      }, 2000);
    },
    handleCancel() {
      this.visible = false;
    },
  },
  props: ['hole'],
};
</script>

<style lang="css" scoped>
.info-container {
  display: flex;
  flex-direction: row;
}
.ant-carousel >>> .slick-slide {
  text-align: center;
  height: fit-content;
  line-height: 160px;
  overflow: hidden;
}

.ant-carousel >>> .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #2e2a2a;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}
.ant-carousel >>> .custom-slick-arrow:before {
  display: none;
}
.ant-carousel >>> .custom-slick-arrow:hover {
  opacity: 0.5;
}

.ant-carousel >>> .slick-slide h3 {
  color: #fff;
}
</style>
